<template>
    <div class="margin-header">
        <TopBar :title="$vuetify.lang.t('$vuetify.AttendanceBureau.pageName')" />
        <div class="box-round display-height">
            <div class="box-content pt-0 px-0">
                <div class="px-7 mt-5 d-flex">
                    <div class="flex-auto mr-2">
                        <v-text-field
                            @input="inputSearch()"
                            class="custom-input-search search"
                            hide-details="auto"
                            outlined
                            v-model="textSearch"
                            :placeholder="$vuetify.lang.t('$vuetify.AttendanceBureau.search.placeholder')"
                        ></v-text-field>
                    </div>
                    <div class="mr-2">
                        <div class="width-item">
                            <v-select
                                placeholder=""
                                class="custom-ddl no-padding"
                                :items="items"
                                v-model="status"
                                outlined
                                @change="inputSearch()"
                            ></v-select>
                        </div>
                    </div>
                    <div class="width-item">
                        <CustomIconDatePicker v-model="date" @onChangeDate="onChangeDate($event)"/>
                    </div>
                </div>
                <div class="d-flex flex-nowrap text-sm mt-4 line-liff-detail">
                    <v-col cols="6" class="px-0 py-0  pl-7 text-blue">
                        {{total}} {{$vuetify.lang.t('$vuetify.AttendanceBureau.people')}}
                    </v-col>
                    <v-col cols="6" class="px-0 py-0  text-right pr-7 text-base-grey2">
                        {{textDate}}
                    </v-col>
                </div>
                <div class="my-3 px-7 text-sm line-liff-detail">
                    <div class="item-info bg-grey-5 rounded px-4 py-2">
                        <div>
                            <v-row @click="isCollapse = !isCollapse">
                                <v-col cols="8">
                                    {{$vuetify.lang.t('$vuetify.AttendanceBureau.detail.title')}}
                                </v-col>
                                <v-col cols="4" class="text-right">
                                    <v-icon small v-if="isCollapse">fas fa-angle-down</v-icon>
                                    <v-icon small v-else>fas fa-angle-up</v-icon>
                                </v-col>
                            </v-row>
                        </div>
                        <div class="border-top mt-2 pt-2 text-base-grey2 line-liff-detail" v-if="!isCollapse">
                            <v-row>
                                <v-col cols="8">
                                    {{$vuetify.lang.t('$vuetify.AttendanceBureau.detail.present')}}
                                </v-col>
                                <v-col cols="4" class="text-right">{{summary.present}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="8">
                                    {{$vuetify.lang.t('$vuetify.AttendanceBureau.detail.late')}}
                                </v-col>
                                <v-col cols="4" class="text-right">{{summary.late}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="8">
                                     {{$vuetify.lang.t('$vuetify.AttendanceBureau.detail.halfDay')}}
                                </v-col>
                                <v-col cols="4" class="text-right">{{summary.halfAbsent}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="8">
                                     {{$vuetify.lang.t('$vuetify.AttendanceBureau.detail.absent')}}
                                </v-col>
                                <v-col cols="4" class="text-right">{{summary.absent}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="8">
                                     {{$vuetify.lang.t('$vuetify.AttendanceBureau.detail.leave')}}
                                </v-col>
                                <v-col cols="4" class="text-right">{{summary.leave}}</v-col>
                            </v-row>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-nowrap header-item mt-4 text-sm line-liff-header-table">
                    <v-col cols="8" class="px-0 py-2 pl-7">
                        {{$vuetify.lang.t('$vuetify.AttendanceBureau.header.detail')}}
                    </v-col>
                    <v-col cols="4" class="px-0 py-2 text-right pr-7">
                        {{$vuetify.lang.t('$vuetify.AttendanceBureau.header.status')}}
                    </v-col>
                </div>
                <div class="font-roboto">
                  <div class="list-item" v-for="(v,i) of list" :key="i">
                       <div class="d-flex pt-0 pr-5 font-weight-bold">
                          <v-col cols="6" class="pb-1 pl-7">
                              <i class="fas fa-address-card mr-2 mb-1"></i>
                              <span>{{v.employeeId}}</span>
                          </v-col>
                          <v-col cols="6" class="pb-1 text-right">{{v.status}}</v-col>
                      </div>
                      <div class="d-flex pt-0 pr-5 pb-2">
                          <v-col cols="8" class=" pb-1 pl-7 pt-0 d-flex font-weight-bold">
                              <div>
                                <i class="fas fa-user mr-3 mb-1"></i>
                              </div>
                              <span class="text-truncate">{{v.name}}</span>
                          </v-col>
                          <v-col cols="4" class=" pb-1 text-right pt-0"><small>{{v.time}}</small></v-col>
                      </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'

import TopBar from '@/components/Liff/Components/header/TopBar.vue'
import CustomIconDatePicker from '@/components/Liff/Components/Input/CustomIconDatePicker.vue'

export default {
    name: 'AttendanceBureau',
    components: {
        TopBar,
        CustomIconDatePicker
    },
    data: function () {
        return {
            delayTimer: null,
            lineUserId: null,
            lineLiffId: process.env.VUE_APP_LINE_LIFF_HISTORY_ATTENDANCE_BUREAU,
            isCollapse: true,
            date: null,
            textSearch: null,
            status: null,
            items: [],
            list: [],
            total: 0,
            summary: {
                absent: 0,
                halfAbsent: 0,
                late: 0,
                leave: 0,
                present: 0
            }
        }
    },
    computed: {
        textDate: function () {
            const lang = localStorage.getItem('lang')
            const date = this.$dateUtil.formatDate(this.date)
            const [d, m, y] = date.split('/')
            const months = this.$dateUtil.months(lang)
            return `${d} ${months[parseInt(m) - 1]} ${y}`
        }
    },
    created: function () {
        this.date = moment().format('YYYY-MM-DD')
    },
    mounted: function () {
        this.initialData()
    },
    methods: {
        initialData: async function () {
            this.$store.dispatch('setLoading', true)
            try {
                const res = await this.axios.get('attendance/status/options')
                if (res && res.data && res.data.status === 'ok') {
                    this.items = res.data.data
                    this.status = res.data.data[0].value
                }

                await this.search()
            } catch {
                // do something with error
            }
            this.$store.dispatch('setLoading', false)
        },
        onChangeDate: function (date) {
            this.search()
        },
        inputSearch: async function () {
            clearTimeout(this.delayTimer)
            this.delayTimer = setTimeout(this.search, 500)
        },
        search: async function () {
            this.$store.dispatch('setLoading', true)
            try {
                // loads data summary
                const lineUserId = await this.$liffUtil.getLineIdForLiff(this.lineLiffId)
                this.lineUserId = lineUserId
                const paramsSummary = {
                    lineId: this.lineUserId,
                    date: this.date
                }
                const resSummary = await this.axios.post('attendances/line/head-bureau/summary', paramsSummary)
                if (resSummary && resSummary.data && resSummary.data.status === 'ok') {
                    this.summary = resSummary.data.data
                    const { absent, halfAbsent, late, leave, present } = this.summary
                    this.total = absent + halfAbsent + late + leave + present
                }

                // load data attendance
                const paramsData = {
                    lineId: this.lineUserId,
                    search: this.textSearch,
                    date: this.date,
                    status: this.status
                }
                const res = await this.axios.post('attendances/line/head-bureau/data', paramsData)
                if (res && res.data && res.data.status === 'ok') {
                    this.list = res.data.data
                }
            } catch {
                // do something with error
            }
            this.$store.dispatch('setLoading', false)
        }
    }
}
</script>

<style lang="scss" scoped>
  @import '@/styles/color.scss';
  .flex-auto {
      flex: 1;
  }
  .width-item {
      width: 40px;
  }
  .border-top {
      border-top: 1px solid $base-grey4;
  }
  .custom-margin {
      margin-top: -10px;
  }
  .rounded {
      border-radius: 5px;
  }

  .header-item {
      margin-top: -5px;
      color: $base-grey2;
      background: #d9e4ed;
      font-size: 14px;
  }
  .list-item {
      padding: 5px 0;
      &:not(:last-child){
          border-bottom: 1px solid $base-grey4;
      }
      i {
          color: $base-grey;
      }
      span {
          color: $base-grey3;
      }
  }
</style>
